module.exports = __webpack_public_path__ + "img/pic-1-1.24660069.jpg";